"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyTransitionTypesMap = void 0;
exports.legacyTransitionTypesMap = {
    outIn: 'OutIn',
    crossfade: 'CrossFade',
    shrinkfade: 'CrossFade',
    swipeHorizontal: 'SlideHorizontal',
    swipeHorizontalFullScreen: 'SlideHorizontal',
    swipeVertical: 'SlideVertical',
    swipeVerticalFullScreen: 'SlideVertical',
    seq_crossFade_All: 'CrossFade',
    seq_shrink_All: 'Shrink',
    swipe_horiz_All: 'SlideHorizontal',
    swipe_vert_All: 'SlideVertical',
    seq_random: 'Random',
    none: 'NoTransition',
};
//# sourceMappingURL=constants.js.map